/**
 * @module api-scm:defectiveRepairOrder
 */
import service from '@/service'

/**
 * @param {{
 * productCode:string,
 * supplier:string}} params
 * @description  查询列表
 */
export function getList(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/defectiveRepairOrder/getList',
    method: 'post',
    data
  })
}

/**
 *
 * @description 导出
 */
export function exportData(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/defectiveRepairOrder/export',
    method: 'post',
    data
  })
}

export function info(id) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/defectiveRepairOrder/info',
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
